// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 600px;
    max-width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    text-align: center;
    position: relative;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

h2 {
    margin-bottom: 20px;
    color: #333;
    font-size: 22px;
    font-weight: bold;
}

p {
    margin: 15px 0;
    color: #4B5563;
    font-size: 14px;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #333;
}

.submit-button {
    padding: 10px 20px;
    background-color: #FF5733;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-top: 15px;
    transition: background-color 0.3s ease;
}

.submit-button:hover {
    background-color: #E04A27;
}

.translation-block {
    margin-bottom: 20px;
    text-align: left;
    border: 1px solid #E5E7EB;
    padding: 15px;
    border-radius: 8px;
    background-color: #F9FAFB;
}

.translation-block h3 {
    margin-bottom: 10px;
    font-size: 16px;
    color: #111827;
    font-weight: 500;
}

.translation-block input,
.translation-block textarea {
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #D1D5DB;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;
}

.translation-block textarea {
    height: 120px;
    resize: none;
    overflow-y: auto;
}

.translation-block input:focus,
.translation-block textarea:focus {
    outline: none;
    border-color: #3B82F6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}

.translations-container {
    max-height: 60vh;
    overflow-y: auto;
    margin-top: 20px;
    border: 1px solid #E5E7EB;
    padding: 10px;
    border-radius: 8px;
    background-color: #F3F4F6;
}

/* Specific styling for video in view modal */
.modal-content video {
    margin-top: 15px;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .modal-content {
        width: 90%;
    }

    .translation-block textarea {
        height: 100px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/EditInstructionModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    width: 600px;\n    max-width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    text-align: center;\n    position: relative;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\nh2 {\n    margin-bottom: 20px;\n    color: #333;\n    font-size: 22px;\n    font-weight: bold;\n}\n\np {\n    margin: 15px 0;\n    color: #4B5563;\n    font-size: 14px;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #333;\n}\n\n.submit-button {\n    padding: 10px 20px;\n    background-color: #FF5733;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-top: 15px;\n    transition: background-color 0.3s ease;\n}\n\n.submit-button:hover {\n    background-color: #E04A27;\n}\n\n.translation-block {\n    margin-bottom: 20px;\n    text-align: left;\n    border: 1px solid #E5E7EB;\n    padding: 15px;\n    border-radius: 8px;\n    background-color: #F9FAFB;\n}\n\n.translation-block h3 {\n    margin-bottom: 10px;\n    font-size: 16px;\n    color: #111827;\n    font-weight: 500;\n}\n\n.translation-block input,\n.translation-block textarea {\n    width: 100%;\n    margin-bottom: 10px;\n    padding: 10px;\n    border: 1px solid #D1D5DB;\n    border-radius: 4px;\n    font-size: 14px;\n    box-sizing: border-box;\n}\n\n.translation-block textarea {\n    height: 120px;\n    resize: none;\n    overflow-y: auto;\n}\n\n.translation-block input:focus,\n.translation-block textarea:focus {\n    outline: none;\n    border-color: #3B82F6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);\n}\n\n.translations-container {\n    max-height: 60vh;\n    overflow-y: auto;\n    margin-top: 20px;\n    border: 1px solid #E5E7EB;\n    padding: 10px;\n    border-radius: 8px;\n    background-color: #F3F4F6;\n}\n\n/* Specific styling for video in view modal */\n.modal-content video {\n    margin-top: 15px;\n    border-radius: 4px;\n}\n\n@media (max-width: 768px) {\n    .modal-content {\n        width: 90%;\n    }\n\n    .translation-block textarea {\n        height: 100px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
